import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SwipeService {
  private _messageSource = new BehaviorSubject("")
  currentMessage = this._messageSource.asObservable()

  constructor() {}

  setDirection(message: string) {
    this._messageSource.next(message)
  }

  public swipeNext (){
    this.setDirection("next")
  }
  
  public swipePrevious (){
    this.setDirection("previous")
  }
}
